interface NormalMain {
    title?: string,
    rowspan?: number,
    item: string,
    col: string,
    val1: string,
    val2: string,
    val3: string,
    val4: string,
    oneEdit: boolean,
    twoEdit: boolean,
    indent: number,
    fontBlue?: boolean
}

let list = [
    {
        title: "销售额",
        rowspan: 10,
        item: "（一）按适用税率计税销售额",
        col: "1",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "其中：应税货物销售额",
        col: "2",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: false,
        indent: 0
    },
    {
        item: "应税劳务销售额",
        col: "3",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: false,
        indent: 39
    },
    {
        item: "纳税检查调整的销售额",
        col: "4",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 39
    },
    {
        item: "（二）按简易办法计税销售额",
        col: "5",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "其中：纳税检查调整的销售额",
        col: "6",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "（三）免、抵、退办法出口销售额",
        col: "7",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "（四）免税销售额",
        col: "8",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "其中：免税货物销售额",
        col: "9",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "免税劳务销售额",
        col: "10",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 39
    },
    {
        title: "税款计算",
        rowspan: 14,
        item: "销项税额",
        col: "11",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "进项税额",
        col: "12",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "上期留抵税额",
        col: "13",
        val1: "",
        val2: "",
        val3: "",
        val4: "--",
        oneEdit: true,
        twoEdit: false,
        indent: 0
    },
    {
        item: "进项税额转出",
        col: "14",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "免、抵、退应退税额",
        col: "15",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "按适用税率计算的纳税检查应补缴税额",
        col: "16",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "应抵扣税额合计",
        col: "17=12+13-14-15+16",
        val1: "",
        val2: "--",
        val3: "",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "实际抵扣税额",
        col: "18（如17<11，则为17，否则为11）",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "应纳税额",
        col: "19=11-18",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "期末留抵税额",
        col: "20=17-18",
        val1: "",
        val2: "",
        val3: "",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "简易计税办法计算的应纳税额",
        col: "21",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "按简易计税办法计算的纳税检查应补缴税额",
        col: "22",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "应纳税额减征额",
        col: "23",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "应纳税额合计",
        col: "24=19+21-23",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        title: "税款缴纳",
        rowspan: 15,
        item: "期初未缴税额（多缴为负数）",
        col: "25",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: false,
        indent: 0
    },
    {
        item: "实收出口开具专用缴款书退税额",
        col: "26",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "本期已缴税额",
        col: "27=28+29+30+31",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "①分次预缴税额",
        col: "28",
        val1: "",
        val2: "--",
        val3: "",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "②出口开具专用缴款书预缴税额",
        col: "29",
        val1: "",
        val2: "--",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "③本期缴纳上期应纳税额",
        col: "30",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: false,
        indent: 0
    },
    {
        item: "④本期缴纳欠缴税额",
        col: "31",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: true,
        twoEdit: true,
        indent: 0
    },
    {
        item: "期末未缴税额（多缴为负数）",
        col: "32=24+25+26-27",
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "其中：欠缴税额（≥0）",
        col: "33=25+26-27",
        val1: "",
        val2: "--",
        val3: "",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 0
    },
    {
        item: "本期应补(退)税额",
        col: "34＝24-28-29",
        val1: "",
        val2: "--",
        val3: "",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 39,
        fontBlue: true
    },
    {
        item: "即征即退实际退税额",
        col: "35",
        val1: "--",
        val2: "--",
        val3: "",
        val4: "",
        oneEdit: false,
        twoEdit: false,
        indent: 39
    },
    {
        item: "期初未缴查补税额",
        col: "36",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 39
    },
    {
        item: "本期入库查补税额",
        col: "37",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 39
    },
    {
        item: "期末未缴查补税额",
        col: "38=16+22+36-37",
        val1: "",
        val2: "",
        val3: "--",
        val4: "--",
        oneEdit: false,
        twoEdit: false,
        indent: 39
    }
];

let NormalMain = {
    list: list,
}
export default NormalMain